import conditions from './smFurtherAction/smConditions';
import states from './smFurtherAction/smStates';
import transitions from './smFurtherAction/transitions/default/smTransitions';
import GAtransitions from './smFurtherAction/transitions/ga/smTransitions';
import IDtransitions from './smFurtherAction/transitions/id/smTransitions';
import MNtransitions from './smFurtherAction/transitions/mn/smTransitions';
import NJtransitions from './smFurtherAction/transitions/nj/smTransitions';
import NMtransitions from './smFurtherAction/transitions/nm/smTransitions';
import NVtransitions from './smFurtherAction/transitions/nv/smTransitions';
import PAtransitions from './smFurtherAction/transitions/pa/smTransitions';
import VAtransitions from './smFurtherAction/transitions/va/smTransitions';


export default (state) => {
    // smConditions and smStates are shared across all states.
    // smTransitions are state specific.
    let result = {
        states: states,
        conditions: conditions
    };

    switch (state) {
        case 'ID': {
            result.transitions = IDtransitions;
            break;
        }
        case 'MN': {
            result.transitions = MNtransitions;
            break;
        }
        case 'GA':{
            result.transitions = GAtransitions;
            break;
        }
        case 'NM' : {
            result.transitions = NMtransitions;
            break;
        }
        case 'NJ' : {
            result.transitions = NJtransitions;
            break;
        }
        case 'PA' : {
            result.transitions = PAtransitions;
            break;
        }
        case 'VA' : {
            result.transitions = VAtransitions;
            break;
        }
        case 'NV':
        case 'GI':{
            result.transitions = NVtransitions;
            break;
        }
        default: {
            result.transitions = transitions;
        }
    }

    return result;
};